import React, { useEffect, useRef } from 'react';
import { scrollIntoWindowView } from "../../helpers/Tools";

const Backdrop = ({
    align,
    containerClass,
    id, 
    toolTipContainerClass,
    toolTipHeading,
    toolTipInfo,
    onClickBackdrop,
    okBtnText,
    scrollIntoView,
    showTooltip
}) => {

    const alignBottom = align && align === 'bottom' ? true : false;
    const tooltipRef = useRef();
    const backdropClass = `backdrop-container${containerClass ? ' ' + containerClass :''}`
    const toolTipClass = `backdrop-tool-tip-container${toolTipContainerClass ? ' ' + toolTipContainerClass : ''} ${alignBottom ? 'backdrop-tooltip--align-bottom' : ''}`;
    const topOffset = -120;

    // If tooltip is aligned to the bottom need to calculate if tooltip needs to overlap children for better visibility on shorter screens
    const getTooltipStyle = () => {
        let tooltipEl = tooltipRef && tooltipRef.current ? tooltipRef.current : null;
        let tooltipStyle = {};

        if (alignBottom) {
            let focusedEl = document.querySelector('.backdrop-tooltip-enabled');
            let windowHeight = window && window.innerHeight ? window.innerHeight : 0;

            let focusedElHeight = focusedEl && focusedEl.clientHeight ? focusedEl.clientHeight : 0;
            let tooltipElHeight = tooltipEl && tooltipEl.clientHeight ? tooltipEl.clientHeight : 0;
            let tooltipOffset = windowHeight - focusedElHeight - tooltipElHeight + topOffset - 64; //last number is tooltip arrow offset

            if (tooltipOffset < 0) {
                if (-tooltipOffset > (focusedElHeight / 2)) {
                    //Setting offset to half of children so doesn't completely overlap children
                    tooltipStyle = { marginTop: `${-(focusedElHeight / 2)}px` };
                } else {
                    tooltipStyle = { marginTop: `${tooltipOffset}px` };
                }
            }
        } else if(tooltipEl) {
            let tooltipElRect = tooltipEl.getBoundingClientRect();
            let windowOffet = window && window.pageYOffset ? window.pageYOffset : 0;
            let arrowOffset = 10;

            if ((tooltipElRect.top + windowOffet) < tooltipEl.clientHeight) {
                tooltipStyle = { marginTop: (-tooltipElRect.top - arrowOffset) + 'px' };
            } else {
                tooltipStyle = { marginTop: (-tooltipEl.clientHeight - arrowOffset) + 'px' };
            }
        }

        return tooltipStyle;
    }

    // Scrolls page to children or tooltip when scrollIntoView is true
    useEffect(() => {
        if (showTooltip) {
            if (scrollIntoView) {
                let tooltipEl = tooltipRef && tooltipRef.current ? tooltipRef.current : null;
                let focusedEl = document.querySelector('.backdrop-tooltip-enabled');
                let scrollEl = alignBottom ? focusedEl : tooltipEl;
                let winHeight = window && window.innerHeight ? window.innerHeight : 0;

                if (scrollEl && tooltipEl && focusedEl) {
                    setTimeout(() => {
                        let tooltipRect = tooltipEl.getBoundingClientRect();
                        let focusedRect = focusedEl.getBoundingClientRect();
                        let isTooltipInView = true;

                        if (alignBottom) {
                            isTooltipInView = tooltipRect && focusedRect.top > -1 && tooltipRect.bottom <= winHeight ? true : false;
                        } else {
                            isTooltipInView = tooltipRect && tooltipRect.top > -1 && focusedRect.bottom <= winHeight ? true : false;
                        }

                        if (!isTooltipInView) {
                            scrollIntoWindowView(null, scrollEl);
                        }
                    }, 500);
                }
            }
        }

    }, [showTooltip]);

    return (<>
        {showTooltip &&
            <div className={backdropClass} id={id}>
            <div className="backdrop" onClick={onClickBackdrop} />
                <div className={toolTipClass} style={getTooltipStyle()} ref={tooltipRef}>
                    {toolTipHeading && <div className="backdrop-tool-tip__heading">{toolTipHeading}</div>}
                    <div className="backdrop-tool-tip__info">{toolTipInfo}</div>
                    <button aria-label="Got It" className="btn text-btn" onClick={onClickBackdrop}>{okBtnText}</button>
                </div>
            </div>
        }
    </>
    );
};

export default Backdrop;

